import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from './AppContext';
import { AppRouter } from './router';
import { applyRuntimeGate } from './mobile-runtime';
import { installHaptics } from './haptics';
import './styles.css';
import './nosivo-design-system.css';
import './mobile-app.css';
import './sidebar.css';
import './dashboard-focus.css';
import './dashboard-compact.css';
import './shift-calendar.css';
import './finance.css';
import './currency-finance.css';
import './task-icons.css';
import './vault-sheet.css';
import './ios-home.css';
import './task-overview.css';

if (applyRuntimeGate()) {
  installHaptics();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </StrictMode>,
  );
}
